<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      保证金管理
      <small>
        /&nbsp;
        <router-link to="/depositreviews" class="TitleStyle">保证金审核列表 </router-link>/&nbsp;合同详情
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">合同详情</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                     <span class="TInfo">基本信息</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                      <li class="TableContent">
                        <span class="TCode">合同编号：</span>
                        <span class="TCodeContent">{{contractDetail.contractNo}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">合同标题：</span>
                        <span class="TCodeContent">{{contractDetail.contractTitle}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">合同区域：</span>
                        <span class="TCodeContent">{{contractDetail.province}}({{contractDetail.city}})</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">合同品类：</span>
<!--                        <span class="TCodeContent">{{String(contractDetail.goodsNameList)}}</span>-->
                        <span class="TCodeContent">
                          <el-tree
                            default-expand-all
                            :data="treeList"
                            :props="{
                              children: 'children',
                              label: 'label'
                            }"
                          />
                        </span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">客户类型：</span>
                        <span class="TCodeContent">{{contractDetail.recomTypeName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">客户名称：</span>
                        <span class="TCodeContent">{{contractDetail.recomName}}</span>
                      </li>
                      <li class="TableContent">
                          <span class="TCode">合同签订时间：</span>
                          <span class="TCodeContent">{{contractDetail.clientSignTime}}</span>
                      </li>
                      <li class="TableContent">
                          <span class="TCode">合同截止时间：</span>
                          <span class="TCodeContent">{{contractDetail.contractTerm}}</span>
                      </li>
                      <div v-for="(item,index) in updataContract" :key="index">
                        <li class="TableContent" v-if="item.mark == 1">
                          <span class="TCode">企业合同上传时间：</span>
                          <span class="TCodeContent">{{item.inputTime}}</span>
                        </li>
                        <li class="TableContent" v-if="item.mark == 1">
                          <span class="TCode">企业合同书：</span>
                          <span class="TCodeContent">
                            <a :href="item.fiteUrl">
                              <img src="@/assets/file.svg" class="fileStyle">
                              查看
                            </a>
                          </span>
                        </li>
                        <li class="TableContent" v-if="item.mark == 2">
                          <span class="TCode">客户合同上传时间：</span>
                          <span class="TCodeContent">{{item.inputTime}}</span>
                        </li>
                        <li class="TableContent" v-if="item.mark == 2">
                          <span class="TCode">客户合同书：</span>
                          <span class="TCodeContent">
                            <a :href="item.fiteUrl" target="_blank">
                              <img src="@/assets/file.svg" class="fileStyle">
                              查看
                            </a>
                          </span>
                        </li>
                        <li class="TableContent">
                          <span class="TCode">合同附件：</span>
                          <span class="TCodeContent">
                          <a
                            v-for="item in contractDetail.accessoryFileList"
                            :key="item.fileId"
                            :href="item.fiteUrl"
                            target="_blank"
                          >
                            <img src="@/assets/file.svg" class="fileStyle">
                            {{item.name}}
                          </a>
                          </span>
                        </li>
                        <li class="TableContent">
                          <span class="TCode">保证金缴纳时间：</span>
                          <span class="TCodeContent">{{depositTime}}</span>
                        </li>
                        <li class="TableContent">
                          <span class="TCode">保证金(元)：</span>
                          <span class="TCodeContent">{{deposit}}</span>
                        </li>
                        <li class="TableContent">
                          <span class="TCode">凭证：</span>
                          <span class="TCodeContent">
                            <img :src="fileUrl" alt="" class="picStyle">
                          </span>
                        </li>
                        <li class="TableContent">
                          <span class="TCode">备注：</span>
                          <span class="TCodeContent">{{contractDetail.note}}</span>
                        </li>
                      </div>
                      <li class="clear"></li>
                    </ul>
                  </div>
                  <div style="height:46px;padding-top:16px;">
                    <a class="btn btn-primary m-r-5" style="float:right;cursor:pointer;color:#fff !important" @click="Goback">返&nbsp;&nbsp;回</a>
                    <span class="clear"></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- end panel -->
          </div>

          <!-- end col-10 -->
        </div>

        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>

  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "ContractReviewDetail",
  data() {
    return {
      contractId:'',
      checkId:'',
      fileUrl:'',
      deposit:'',
      contractDetail:[],
      updataContract: [],
      treeList: [],
      depositTime: ''
    };
  },
  mounted: function() {
    if(this.$route.query.contractId){
      this.contractId = this.$route.query.contractId;
    }
    if(this.$route.query.fileUrl){
      this.fileUrl = this.$route.query.fileUrl;
    }
    if(this.$route.query.deposit){
      this.deposit = this.$route.query.deposit;
    }
    if(this.$route.query.checkId){
      this.checkId = this.$route.query.checkId;
    }
    if (this.$route.query.depositTime) {
      this.depositTime = this.$route.query.depositTime
    }
    this.initdata();
  },
  methods: {
    Goback() {
      if(this.checkId == 1){
        this.$router.push({path: '/depositreviews'});
      }else if(this.checkId == 2){
        this.$router.push({path: '/depositlist'});
      }else {
        this.$router.push({path: '/depositreviews'});
      }
    },
    initdata() {
      let that = this;
      const options = {
        url: "distribution/B2cTobContractController/selectContractDetails",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          contractId: that.contractId
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.contractDetail = response.data.data;
          if(that.contractDetail.recomType == 0){
            that.contractDetail.recomTypeName = "服务商";
          }else if(that.contractDetail.recomType == 1){
            that.contractDetail.recomTypeName = "分销商";
          }else{
            that.contractDetail.recomTypeName = "未知";
          }
          if(that.contractDetail.tobFilesList.length !==0){
            that.updataContract = that.contractDetail.tobFilesList;
          }

           if(that.contractDetail.clientSignTime != '' && that.contractDetail.clientSignTime != null){
            that.contractDetail.clientSignTime = that.contractDetail.clientSignTime.slice(0,10);
          }

          const resData = response && response.data && response.data.data

          that.$set(that.contractDetail, 'accessoryFileList', (resData.accessoryFileList || []).map((item, i) => {
            const arr = String(item.fiteUrl).split('--')
            let fileName

            if (arr.length <= 1) {
              fileName = '附件' + (i + 1)
            } else {
              fileName = arr.pop()
            }

            return {
              ...item,
              fiteUrl: arr.join(''),
              name: fileName
            }
          }))

          that.treeList = (resData.infoFormList || []).map(brand => ({
            label: brand.brandName,
            children: (brand.seriesList || [])
              .filter(item => item)
              .map(series => ({
                label: series.seriesName
              }))
          }))
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}
.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 60px 280px;
  border: 1px #e5e5e5 solid;
  border-top: none;
  font-size: 16px;
}
.TitleStyle {
  color: #6a7786;
}
.TableContent {
  float: left;
  width: 50%;
}
.GContentUl {
  list-style: none;
  margin: 0;
  padding: 0;
}
.TCode {
  color: #999999;
  text-align: right;
  width: 180px;
  overflow: hidden;
  float: left;
  padding: 16px;
}
.TCodeContent {
  float: left;
  width: calc(100% - 180px);
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding: 16px;
}
.TCodeContent a {
  display: flex;
  align-content: start;
  align-items: center;
  margin-top: 12px;
}

.TCodeContent a:first-child{
  margin-top: 0;
}

.TCodeContent .fileStyle {
  width: 40px;
}
.TCodeContent .picStyle {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/depositdetail.vue